import Modal from 'react-modal';
import {useState} from 'react'
import { API_URL } from '../../../config/api';
import { useAuth } from '../../../context/AuthContext';

import Alfredo from '../../../assets/imagens/Alfredo.png'

import Button from '../../ui/Button';
import Input from '../../ui/Input/Input';

import './EsqueciSenha.css'
export default function EsqueciSenha({modalIsOpen, closeModal}){
    const [email, setEmail] = useState()

    const {logout} = useAuth()

    const emitirSom = ()=>{
            const audio = new Audio('/sounds/popUp3.mp3')
            audio.play().catch(error => console.log("Não foi possível reproduzir este audio: ", error)) 
    }

   const handleEsqueciSenha = async () => {
        try {
            const response = await fetch(
                `${API_URL}/reset-password?email=` +
                encodeURIComponent(email),
                {
                    method: "POST"
                }
            );

            const data = await response.text();
             if (response.status === 403) {
                    logout()
                    return
                }

            if (!response.ok) {
                throw new Error(data || "Erro ao solicitar redefinição de senha.");
            }

            console.log(data);
            alert("Enviado, verifique sua caixa de entrada.")

        } catch (error) {
            console.error("Erro:", error);
        }
    };

    return (
        <Modal  
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            className='esqueciSenhaModal'
            overlayClassName="overlayModal"
            onAfterOpen={emitirSom}
            >
            <img className='avatarAlfredo' width={200} src={Alfredo} />


            <div>
    
                <div className="esqueciSenhaTexto">
                    <h1>Esqueceu sua senha?</h1>
                    <h3>Não se preocupe! Recupere sua senha agora mesmo. </h3>

                    <p>Enviaremos o link de redefinição em seu e-mail</p>
                </div>
                <div className="esqueciSenhaInputs">
                    <Input  
                        name="E-mail"
                        placeholder="Digite seu e-mail corporativo."
                        value={email}
                        onChange={(e)=> setEmail(e.target.value)}
                        type='text'
                        label="Digite seu E-mail corporativo"/>
                </div>

                <Button onClick={() => handleEsqueciSenha()} text="Enviar e-mail" className="btnAmarelo" />
            </div>

        </Modal>
    )
}